/*
 * Copyright © 2023 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import type {CountryCode} from '@dv/shared/backend/model/country-code';
import {DvbUtil} from '../util';
import type {IsoObject} from './IsoObject';

export class Country implements IsoObject {

    /**
     * @param isoCode ISO 3166 two-letter country code
     * @param displayName
     */
    public constructor(
        public isoCode: CountryCode,
        public displayName: string = DvbUtil.getDisplayNameFromIsoCode(isoCode),
    ) {
    }

    public static apiResponseTransformer(data: any): Country {
        return new Country(data.isoCode, data.displayName);
    }

    public toRestObject(): string {
        return encodeURIComponent(this.isoCode);
    }
}
